const Page500 = () => {
  return (
    <div
      style={{ height: '100%', alignItems: 'center', display: 'flex', justifyContent: 'center' }}
    >
      Erreur Server side
    </div>
  )
}

export default Page500
